module.exports = __webpack_public_path__ + "static/media/26.25dde83b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/unused icon/26.svg
// module id = 419
// module chunks = 14